<!-- Panel-->
<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column w-35pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>Add / Edit Category</h2>
            </div>         
            <div class="panel-left-btn">
                <button *ngIf="isEditView" (click)="fnShowConfigureshowLoggingAlertPanel()" class="btn eod-btn-outline-warning mr-2">{{"log"| translate}}</button>   
                <button (click)="fnSaveExpenseCategory()" 
                [ngClass]="{'disabled': !hasFormChanges }"
                class="btn eod-btn-primary mr-2"
                [disabled]="!hasFormChanges">
                    {{ "label_save" | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="onClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block mt-2">
                <div class="row">
                    <div class="col-md-12 col-sm-12 px-0 ">
                        <div class="d-flex pb-1">
                            <input type="checkbox" switch="bool" id="toggle-1" [checked]="vendorCategory.isActive"
                            (change)="onIsCatActiveChange()">
                            <label class="mb-0 cursor-pointer" for="toggle-1">
                                <span class="ml-5 eod-text-secondary fw-600 f-18 text-nowrap">{{activeCatButtonText}}</span>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 px-0 mt-4">
                        <div class="input-group">
                            <input type="text" class="form-control" required=""
                                (value)="vendorCategory.expenseCategoryName"
                                [(ngModel)]="vendorCategory.expenseCategoryName" name="expenseCategoryName"
                                id="expenseCategoryName" (change)="onCategoryNameChange($event)"
                                (input)="onCategoryNameChange($event)"
                                [ngClass]="{'has-value': vendorCategory.expenseCategoryName}"
                                maxlength="100">
                            <label for="expenseCategoryName">
                                {{'category_name' | translate}}<span>*</span>
                            </label>
                            <p class="d-inline float-right f-10" [ngClass]="{'alert-danger' : vendorCategory.expenseCategoryName.length== 100}">{{vendorCategory.expenseCategoryName.length}}/100</p>
                            <div *ngIf="isNameEmpty" class="alert-danger d-inline ">
                                {{'required_validation' | translate}}
                            </div>
                            <div *ngIf="serverError" class="alert-danger">
                                {{serverError}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 px-0 mt-4">
                        <div class="input-group">
                            <input type="text" class="form-control" required=""
                                [(ngModel)]="vendorCategory.accountingCode" value="vendorCategory.accountingCode"
                                name="accCostCode" id="accCostCode" (change)="onAccCostCodeChange($event)"
                                (input)="onAccCostCodeChange($event)"
                                [ngClass]="{'has-value': vendorCategory.accountingCode}"
                                maxlength="100">
                            <label for="accCostCode">
                                {{'special_cat_wizard_text33' | translate}}
                            </label>
                            <p class="d-inline float-right f-10" [ngClass]="{'alert-danger' : vendorCategory?.accountingCode.length== 100}">{{vendorCategory?.accountingCode.length}}/100</p>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 px-0 mt-4">
                        <div class="input-group">
                            <ng-select class="solo-dropdown filterDropdown" [items]="taxRateList" bindLabel="value"
                                placeholder="Tax Rate" [clearable]="false" [selectOnTab]="true" bindValue="id"
                                [(ngModel)]="vendorCategory.taxRateId"
                                notFoundText="{{ 'no_data_available' | translate }}"
                                (change)="onTaxRateChange($event)">
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Panel End-->

<app-alert-panel [data]="alertPanelModel" (callbackEvent)="alertPanelReceiver($event)"></app-alert-panel>